"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPOWER_POLICY_4 = exports.EMPOWER_POLICY_3 = exports.EMPOWER_POLICY_2 = exports.EMPOWER_DEFAULT_POLICY = exports.EMPOWER_BONUS_2 = exports.EMPOWER_BONUS_1 = exports.Empower = void 0;
const Party_1 = require("./Party");
const PartyName_1 = require("./PartyName");
const Resources_1 = require("../../Resources");
const TurmoilPolicy_1 = require("../TurmoilPolicy");
const Tags_1 = require("../../cards/Tags");
const SelectAmount_1 = require("../../inputs/SelectAmount");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const MarsCoalition_1 = require("../../cards/community/corporations/MarsCoalition");
const EmpowerDefaultAction_1 = require("../../cards/turmoil/standardActions/EmpowerDefaultAction");
class Empower extends Party_1.Party {
    constructor() {
        super(...arguments);
        this.name = PartyName_1.PartyName.EMPOWER;
        this.description = 'Champions efficient energy utilization for sustainable growth.';
        this.bonuses = [exports.EMPOWER_BONUS_1, exports.EMPOWER_BONUS_2];
        this.policies = [exports.EMPOWER_DEFAULT_POLICY, exports.EMPOWER_POLICY_2, exports.EMPOWER_POLICY_3, exports.EMPOWER_POLICY_4];
    }
}
exports.Empower = Empower;
class EmpowerBonus01 {
    constructor() {
        this.id = 'eb01';
        this.isDefault = true;
        this.description = 'Gain 2 M€ for each Power tag you have';
    }
    getScore(player) {
        return player.getTagCount(Tags_1.Tags.ENERGY, 'raw') * 2;
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class EmpowerBonus02 {
    constructor() {
        this.id = 'eb02';
        this.description = 'Gain 1 M€ for each Energy production you have';
        this.isDefault = false;
    }
    getScore(player) {
        return player.getProduction(Resources_1.Resources.ENERGY);
    }
    grant(game) {
        game.getPlayers().forEach((player) => {
            player.addResource(Resources_1.Resources.MEGACREDITS, this.getScore(player));
        });
    }
}
class EmpowerPolicy01 {
    constructor() {
        this.isDefault = true;
        this.id = TurmoilPolicy_1.TurmoilPolicy.EMPOWER_DEFAULT_POLICY;
        this.description = 'Spend X M€ to gain X energy';
    }
    canAct(player, isDominantPartyAction = false) {
        return player.canAfford(1) && player.canUseSingleTurmoilAction(isDominantPartyAction);
    }
    action(player, isDominantPartyAction = false) {
        const availableMC = player.spendableMegacredits();
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => new SelectAmount_1.SelectAmount('Select amount of energy to gain', 'Gain energy', (amount) => {
            player.deductResource(Resources_1.Resources.MEGACREDITS, amount);
            player.addResource(Resources_1.Resources.ENERGY, amount);
            player.game.log('${0} used Turmoil ${1} action', (b) => b.player(player).card(new EmpowerDefaultAction_1.EmpowerDefaultAction()));
            player.game.log('${0} spent ${1} M€ to gain ${2} energy', (b) => b.player(player).number(amount).number(amount));
            return undefined;
        }, 1, availableMC)));
        MarsCoalition_1.MarsCoalition.handleSingleUsePolicyLogic(player, isDominantPartyAction);
        return undefined;
    }
}
class EmpowerPolicy02 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_2;
        this.description = 'When you place a tile, gain 1 energy';
        this.isDefault = false;
    }
    onTilePlaced(player) {
        player.addResource(Resources_1.Resources.ENERGY);
    }
}
class EmpowerPolicy03 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_3;
        this.description = 'When you gain or lose energy production, gain 2 energy';
        this.isDefault = false;
    }
}
class EmpowerPolicy04 {
    constructor() {
        this.id = TurmoilPolicy_1.TurmoilPolicy.EMPOWER_POLICY_4;
        this.description = 'When you play a Power tag, you pay 3 M€ less for it';
        this.isDefault = false;
    }
}
exports.EMPOWER_BONUS_1 = new EmpowerBonus01();
exports.EMPOWER_BONUS_2 = new EmpowerBonus02();
exports.EMPOWER_DEFAULT_POLICY = new EmpowerPolicy01();
exports.EMPOWER_POLICY_2 = new EmpowerPolicy02();
exports.EMPOWER_POLICY_3 = new EmpowerPolicy03();
exports.EMPOWER_POLICY_4 = new EmpowerPolicy04();
//# sourceMappingURL=Empower.js.map